import { IconMapCar16, IconMapWalk16 } from '@cian/ui-kit-design-tokens/icons';
import { Body1, Body2 } from '@cian/ui-kit/typography';
import * as React from 'react';

import * as styles from './GeoTravelTime.css';
import { ETransportType } from '../../types/recommendation';

interface IGeoTravelTimeProps {
  textVariant?: 'body1' | 'body2';
  transportType: ETransportType;
  time: number | string;
}

export const GeoTravelTime: React.FC<IGeoTravelTimeProps> = ({ textVariant = 'body2', transportType, time }) => {
  const Icon = transportType === ETransportType.Walk ? IconMapWalk16 : IconMapCar16;
  const Text = textVariant === 'body1' ? Body1 : Body2;

  return (
    <div className={styles['container']}>
      <div data-name={transportType} className={styles['icon']}>
        <Icon display="block" color="icon-secondary-default" />
      </div>

      <Text display="inline" color="gray60_100">
        {time}
      </Text>
    </div>
  );
};
